import React from "react"
import { Box, CircularProgress, Typography } from "@mui/joy"
import { useTranslation } from "react-i18next"

const CampaignSummary = ({ summaryFields = [], mappingValue = [], modelFields = [], isSaving = { current: false } }) => {
    const { t } = useTranslation()

    return (
        <Box className="form-element form-element-campaign-summary col-12">
            <Box sx={{ p: 3, opacity: isSaving.current ? 0.5 : 1 }}>
                <Typography level="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                    {t('campaignSummary')}
                </Typography>
                <Typography level="body-sm" sx={{ color: 'text.secondary', mb: 3 }}>
                    {t('campaignWarning')}
                </Typography>

                <Typography level="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                    {t('Info')}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {summaryFields.map((field, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', pb: 1, borderBottom: '2px solid #ccc' }}>
                            <Typography level="body-md" sx={{ fontWeight: 'bold' }}>{field.label}</Typography>
                            <Typography level="body-md">{field.value}</Typography>
                        </Box>
                    ))}
                </Box>

                {/* <Typography level="body-md" sx={{ fontWeight: 'bold', mt: 3 }}>{t('Rules')}</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    {mappingValue.length > 0 ? (
                        mappingValue.map((rule, index) => {
                            const fieldLabel = modelFields.find(f => f.key === rule.field)?.label || rule.field
                            const valueText = Array.isArray(rule.value)
                                ? rule.value.join(', ').toLowerCase()
                                : String(rule.value).toLowerCase()
                            return (
                                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', pb: 1, borderBottom: '2px solid #ccc' }}>
                                    <Typography level="body-md" sx={{ fontWeight: 'bold' }}>
                                        {fieldLabel}
                                    </Typography>
                                    <Typography level="body-md">
                                        {rule.operator} {valueText}
                                    </Typography>
                                </Box>
                            )
                        })
                    ) : (
                        <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
                            {t('noRulesDefined')}
                        </Typography>
                    )}
                </Box> */}
            </Box>

            {isSaving.current && (
                <Box className="overlay-progress">
                    <CircularProgress className="circular-progress" />
                </Box>
            )}
        </Box>
    )
}

export default CampaignSummary
